import React, { useState, useEffect, useCallback } from 'react';
import { Buttons, IF } from 'lidya-common-components';
import classnames from 'classnames';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import { useGlobalData } from '../../providers/globalDataProvider/globalDataProvider.useGlobalData';
import { COMPONENTS } from '../common/webSiteLanguages';
import { getLinkByComponentName } from '../../hooks/useNavigationLinks';
import { ContextLink } from '../common/contextLink';

import './cookieMessage.less';

const LinkToCookies = ({ label }) => {
  const { country, language } = useGlobalData();
  const link = getLinkByComponentName({
    componentName: COMPONENTS.COOKIES,
    country,
  });
  const slug = link[`slug_${language}`];
  const { new_tab: newTab } = link;
  return (
    <ContextLink
      className="a-cookie__link"
      aria-label={label}
      id={`Cookies${slug}`}
      to={slug}
      target={newTab ? '_blank' : undefined}
    >
      <strong>{`${label} `}</strong>
    </ContextLink>
  );
};

const CookieMessage = ({ specificMessage }) => {
  const [userAcceptsCookies, setAcceptsCookies] = useState(true);
  const { t } = useTranslation();
  const [specific, setSpecific] = useState(false);

  useEffect(() => {
    const cookieValue = localStorage.getItem('accepts_cookies') === 'true';
    if (userAcceptsCookies !== cookieValue) {
      setAcceptsCookies(cookieValue);
    }
  }, []);

  const onAccept = useCallback(() => {
    if (!specificMessage) {
      localStorage.setItem('accepts_cookies', true);
    } else {
      localStorage.setItem('accepts_cookies_landing', true);
      setSpecific(false);
    }
    setAcceptsCookies(true);
  }, [specificMessage]);

  const cookieLink = !specificMessage
    ? t('web.popup.cookies')
    : t('web.landing.cookie.link');
  const cookieMsg = !specificMessage
    ? t('web.privacy.conditions.secondary')
    : t('web.landing.cookie.secondary');
  const cookieTitle = !specificMessage
    ? t('web.popup.cookies.message')
    : t('web.landing.cookie.message');

  return (
    <IF condition={!userAcceptsCookies}>
      <div
        className={classnames(
          'o-cookie__messageContainer',
          { '-show': !userAcceptsCookies },
          { '-specific': specific },
        )}
      >
        <div className="a-cookie__message">
          {`${cookieTitle} `}
          <LinkToCookies label={cookieLink} />
          {`${cookieMsg} `}
        </div>

        <div className="m-cookie__btnContainer">
          <Buttons.SmallIconButton
            type={Buttons.BUTTON_TYPES.SMALL_ICON_TERTIARY}
            icon="close"
            className="a-cookie__btn"
            onClick={onAccept}
            title="Close"
          />
        </div>
      </div>
    </IF>
  );
};

export default CookieMessage;
